import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsSnowNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M14.94 9.75l-.98-.56-1.46.91-1.37-.8V6.68l1.38-.79 1.44.89.98-.56-1.43-.89 1.72-.99-.49-.87-1.74.99-.06-1.72-.98.57.06 1.71-1.39.8L8.5 4.7V3.05l1.5-.8V1.12l-1.5.79V0h-1v1.91L6 1.11v1.14l1.5.8V4.7L5.37 5.82l-1.44-.84.06-1.69-.98-.57-.06 1.69-1.71-1-.51.86 1.73 1.01L1 6.19l.98.57 1.45-.91 1.43.83v2.61l-1.43.82L2 9.22h-.01l-.98.56 1.43.9-1.73.98.5.87 1.73-.99.07 1.72.98-.57-.07-1.71 1.44-.82h.01L7.5 11.3v1.56l-1.5.8v1.13L7.5 14v2h1v-2.01l1.5.79v-1.12l-1.5-.8V11.3l2.12-1.14 1.38.8-.06 1.69v.01l.98.56.06-1.69 1.72 1.01.5-.87-1.72-1 1.46-.92zm-4.81-.46L8 10.43 5.86 9.29v-2.6L8 5.56l2.13 1.13v2.6z"
        fill=""
      />
    </svg>
  )
);
SvgSportsSnowNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgSportsSnowNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsSnowNormalXsmall;
